import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { resetPassword } from "../../../services/auth";
import { useSearchParams, useNavigate } from "react-router-dom";

export const useResetPassword = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const confirmation = searchParams.get("confirmation") || "";
  const email = searchParams.get("username") || "";
  //const userdomain = searchParams.get("userdomain") || "";

  const restFormik = useFormik({
    initialValues: {
      password: "",
      confirmPassword: "",
    },
    onSubmit: () => {},
    validationSchema: Yup.object({
      password: Yup.string()
        .required("Password is required")
        .min(8, "Password must be at least 8 characters"),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref("password"), ""], "Passwords must match")
        .required("Please confirm your password"),
    }),
  });

  const { values } = restFormik;

  const handleResetPassword = async () => {
    const response: any = await resetPassword(
      values.password,
      email,
      confirmation
    );
    if (response.statusCode === 200 && response.isSuccess) {
      toast.success(response.message);
      restFormik.resetForm();
      navigate("/");
    } else {
      toast.error(response.message);
    }
  };

  return {
    restFormik,
    handleResetPassword,
  };
};
